<template>
            <main class="main">
                <div class="worker-add">
                    <div class="worker-add_item">
                        <label for="surname" class="worker-add_label">Фамилия</label>
                        <input autocomplete="off" name="surname" v-model="surname" id="surname" v-validate="'required'" data-vv-validate-on="blur" class="worker-add_input" type="text">
                        <span class="text-danger text-sm">{{ errors.first('surname') }}</span>
                    </div>
                    <div class="worker-add_item">
                        <label for="name" class="worker-add_label">Имя</label>
                        <input autocomplete="off" name="name" v-model="name" id="name" v-validate="'required'" class="worker-add_input" data-vv-validate-on="blur" type="text">
                        <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                    </div>
                    <div class="worker-add_item">
                        <label for="patronymic" class="worker-add_label">Отчество</label>
                        <input autocomplete="off" name="patronymic" v-model="patronymic" id="patronymic" class="worker-add_input" data-vv-validate-on="blur" type="text">
                      <span class="text-danger text-sm">{{ errors.first('patronymic') }}</span>
                    </div>
                    <div class="worker-add_item">
                        <label for="email" class="worker-add_label">E-mail</label>
                        <input autocomplete="off" name="email" v-model="email" id="email" v-validate="'required|email'" class="worker-add_input" data-vv-validate-on="blur" type="text">
                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                        <span class="text-danger text-sm" v-if="mail_isset">{{ mail_isset }}</span>
                    </div>
                    <div class="worker-add_item">
                        <label for="role" class="worker-add_label">Роль на платформе</label>
                        <app-select :options="roles" id="role" v-model="role"/>
                        <span class="text-danger text-sm" v-if="role_error">{{ role_error }}</span>
                    </div>
                    <app-button big @click="sendInvite()">Отправить приглашение</app-button>
                </div>
            </main>
</template>

<script>
import AppSelect from "@/components/app-select";
import AppButton from "@/components/app-button";


export default {
    name: "edit",
    data() {
        return {
            roles: [],
            name: '',
            surname: '',
            patronymic: '',
            email: '',
            role: '',
            role_error: null,
            mail_isset: null,
            escape: true
        }
    },
    components: {
      AppButton,
      AppSelect,
    },
    mounted() {
        if (localStorage.getItem('type') == 1) {
            this.roles = [
                'Руководитель отдела',
                'Менеджер по продажам',
                'Менеджер клиентской поддержки',
                'Менеджер по дропшиппингу'
            ];
        } else {
            this.roles = ['Руководитель отдела', 'Старший менеджер по закупкам', 'Менеджер по закупкам'];
        }
    },
    beforeRouteLeave (to, from, next) {
        // If the form is dirty and the user did not confirm leave,
        // prevent losing unsaved changes by canceling navigation
        if (this.confirmStayInDirtyForm()){
            next(false)
        } else {
            // Navigate to next view
            next()
        }
    },
    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
    methods: {
        confirmLeave() {
            return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
        },

        confirmStayInDirtyForm() {
            return this.escape && this.dirty() && !this.confirmLeave()
        },
        dirty() {
            if (this.surname) {
                return true;
            }
            if (this.name) {
                return true;
            }
            if (this.patronymic) {
                return true;
            }
            if (this.email) {
                return true;
            }

            return false;
        },
        beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
                // Cancel the event
                e.preventDefault()
                // Chrome requires returnValue to be set
                e.returnValue = ''
            }
        },
        sendInvite() {
            this.role_error = null;
            this.mail_isset = null;
            if (this.role == ''){
              this.role_error = 'Поле роль на платформе обязательно к заполнению.';
            }
            let self = this;
            this.$validator.validateAll().then(success => {
                if (success && !this.role_error) {
                    this.$http.post( '/send-invite',{
                        token: localStorage.getItem('token'),
                        name: this.name,
                        surname: this.surname,
                        patronymic: this.patronymic,
                        email: this.email,
                        role: this.role
                    }).then(({data}) => {
                        if (data.success) {
                            this.$toast.success('Приглашение успешно отправлено!');
                            this.escape = false;
                            this.$router.push('/users');
                            this.name = '';
                            this.surname = '';
                            this.patronymic = '';
                            this.email = '';
                        }
                    }).catch(function(error){
                      if (error.response.data.errors){
                        if (error.response.data.errors.email){
                          self.mail_isset =  error.response.data.errors.email[0]
                        }
                      }
                        // this.$toast.error('Ошибка!');
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.worker-add {
    max-width: 328px;

    &_item {
        margin-bottom: 16px;
    }

    &_label {
        font-size: 14px;
        line-height: 16px;
        font-weight: normal;
        color: #000000;
        display: block;
        margin-bottom: 7px;
    }

    &_input {
        background: #FFFFFF;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        height: 40px;
        width: 100%;
        outline: none;
        padding: 0 15px;
        color: #7A818F;
        font-size: 12px;
        line-height: 14px;
    }

    &_select {
        background: #FFFFFF;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        height: 40px;
        width: 100%;
        padding: 0 15px;
        color: #7A818F;
        font-size: 12px;
        line-height: 14px;
    }
}
</style>
